import { isTokenValid } from '@/auth-tools'

//const url = "https://siprem-221621.appspot.com/";
//const url = "http://localhost:8080/";

//const url = "https://apparent-labrador-preferably.ngrok-free.app/";
//const url = "http://192.168.0.101:8080/";
//const url = "http://201.102.179.156:8080/";
//const url = "https://siprem-demo.appspot.com/";
//const url = "http://35.184.4.154:8080/";
//const url = "https://recaudacion.gobinet.mx/";
const url = "https://recaudacion.gobrecservices.com/";
//const url = "https://tphavawsqa.a.pinggy.link/"
//const url = "https://optimal-central-pug.ngrok-free.app/";
//const url = "https://siprem-demo2.appspot.com/";


//const url2 = "http://192.168.0.101:8080/";
const url2 = "https://recaudacion.gobrecservices.com/";
//const url2 = "https://recaudacion.gobinet.mx/";
//const url2 = "http://localhost:8080/";
//const url2 = "https://tphavawsqa.a.pinggy.link/";
//const url2 = "https://recaudacion.gobrecservices.com/";

//const url2 = "https://optimal-central-pug.ngrok-free.app/";
//const url2 = "https://apparent-labrador-preferably.ngrok-free.app/";

const urlIUSAHost = "http://localhost:57299/";
const urlPinpad = "http://localhost:56552/api/values";


const server = {
    liquidacion: url + 'generarliquidacion',
    liquidacionorden: url + 'cargaliquidacionorden',
    cargapagosgem : url + 'cargapagosgem',
    cargapagosreferencia : url + 'cargapagosreferencia',
    exentaPeriodo: url + 'exentaperiodo',
    cancelaExentaPeriodo: url + 'cancelaparcialidadexenta',
    ordenes: url + 'ordenespago',
    recibos: url + "recibos",
    detallePago : url + 'detallepagotramite',
    editarPago : url + 'editarpago',
    ordenpago: url + 'generarordenpago',
    generarconvenio: url + 'generarconvenio',
    tramites: url + 'expedientesenlinea',
    generartramite : url + 'generartramite',
    ordenpagopdf : url + 'consultaordenpago',
    authenticate: url + 'authenticate',
    reportes: url + 'reportes',
    cancelarorden: url + 'cancelarorden',
    editarContribuyente: url + 'editarcontribuyente',
    editarBasesContribuyente: url + 'editarbasescontribuyente',
    editarUbicacionContribuyente: url + 'editarubicacioncontribuyente',
    eliminaContribuyente: url + 'eliminacontribuyente',
    editarConsumosAgua : url + 'editarconsumosagua',
    consultaConsumoAgua : url + 'consumoaguadetalle',
    consultaConsumoDerivaciones : url + 'consumoderivaciones',
    actualizaconsumoderivaciones : url + 'actualizaconsumoderivaciones',
    agregaconstruccion : url + 'agregaconstruccion',
    borraconstruccion : url + 'borraconstruccion',
    editaconstruccion : url + 'editaconstruccion',
    altamanifestacion : url + 'altamanifestacion',
    cambiatipovaluacion : url + 'cambiatipovaluacion',
    terrenocarto : url + 'terrenocarto',
    construccionescarto : url + 'construccionescarto',

    altaconsumoagua : url + 'altaconsumoagua',
    generadoccontrib : url + 'generadoccontrib',
    buscarContribuyente: url + 'buscarcontribuyente',
    buscarContribuyentes: url + 'buscarcontribuyentes',
    consultaadeudo: url + 'consultaadeudo',
    facturarRecibo: url + "facturarrecibo",
    datosFacturacion: url + "datosfacturacion",
    generarLineaCaptura: url + "generarlineacaptura",
    generarLineaCapturaMeta: url + "generarlineacapturameta",
    pagosContribuyente: url + "pagoscontribuyente",
    movsContribuyente: url + "movscontribuyente",
    movsMedidores: url + "historicomedidor",
    movsConsumos : url + "historicoconsumos",
    expedientesContribuyente: url + "expedientescontribuyente",
    ubicacionContribuyente: url + "ubicacioncontribuyente",
    cobro: url + "cobroliq",
    gent3pinpad : url +"generar3dpinpad", 
    genct3pinpad : url +"generarcan3dpinpad", 
    updct3pinpad : url + "senres3dpinpad",
    transacciones3D : url + "transacciones3dusuario",
    updateTransaccion3D : url + "updatetransaccion3d",
    agregarContribuyente: url + "agregarcontribuyente",
    obtenerSiguienteCuenta: url + "siguientecontrato",
    obtenerSiguientePredio: url + "siguientepredio",
    vinculaAutogestionIusa: url + "conectaservicioiusa",
    consultaPredio: url + "consultarpredio",
    cancelarCfdi: url + "cancelacionfactura",
    actualizarCfdi: url + "estadofactura",
    consultarRecibo: url + "consultarrecibo",
    consultaDoc: url+"consultadoc",
    facturasrecibo: url + "facturasrecibo",
    cancelarRecibo: url + "cancelarrecibo",
    recibo: url + "recibo",
    ultrecibo : url + "ultreccontribuyente",
    enviarrecibo : url + "enviarrecibo",
    registrarCorreoPago: url + "registrarcorreopago",
    verificarCorreoPago: url + "verificarcorreopago",
    servicios : url + "servicios",
    generaPagoEnLinea: url+"generacionpagoenlinea",
    agregacalle: url+"agregacalle",
    editanombrecalle : url + "editanombrecalle",
    agregacolonia: url+"agregacolonia",
    agregalocalidad: url+"agregalocalidad",
    validarclavecat : url + "validarclavecat",
    fusionpredios : url + "fusionpredios",
    subdivisionpredio : url + "subdivisionpredio",
    gruposubsidios: url + "gruposubsidios",
    quitasubsidio : url + "quitasubsidio",
    agregasubsidio : url + "agregasubsidio",
    cambiarpass : url + "cambiarpass",
    cambiaroficina : url + 'cambiaroficina',
    rootsa: url + "genkaviraservices",
    contratosiusa : url + 'contratosiusaautogestion',
    catsroot : url + 'catsroot',
    consultatransroot: url + 'consultatrans',
    updatetransroot: url + 'updatetrans',
    recorridoactualagua: url + 'recorridoactualagua',
    registrarecorridoagua : url + 'registrarecorridoagua',

    cobroPinpad: urlPinpad,
    pagotarjetaiusa : urlIUSAHost + 'api/values',

    consultaparquimetro : url + 'consultaparquimetro',
    consultaparquimetrousr : url + 'consultaparquimetrousr',
    correoparquimetro : url + 'correoparquimetro',
    generacionpagoenlineaparq : url + 'generacionpagoenlineaparq' ,
    geninfraccion : url + 'geninfraccion',
    placaparquimetro : url + 'placaparquimetro'



};

const server2 = {
    liquidacion: url2 + 'generarliquidacion',
    cargapagosgem : url + 'cargapagosgem',
    cargapagosreferencia : url + 'cargapagosreferencia',
    liquidacionorden: url2 + 'cargaliquidacionorden',
    exentaPeriodo: url2 + 'exentaperiodo',
    cancelaExentaPeriodo: url2 + 'cancelaparcialidadexenta',
    ordenes: url2 + 'ordenespago',
    recibos: url2 + "recibos",
    detallePago : url2 + 'detallepagotramite',
    ordenpago: url2 + 'generarordenpago',
    generarconvenio: url + 'generarconvenio',
    tramites: url2 + 'expedientesenlinea',
    generartramite : url2 + 'generartramite',
    ordenpagopdf : url2 + 'consultaordenpago',
    authenticate: url2 + 'authenticate',
    reportes: url2 + 'reportes',
    cancelarorden: url2 + 'cancelarorden',
    editarContribuyente: url2 + 'editarcontribuyente',
    editarBasesContribuyente: url2 + 'editarbasescontribuyente',
    editarUbicacionContribuyente: url2 + 'editarubicacioncontribuyente',
    eliminaContribuyente: url2 + 'eliminacontribuyente',
    editarConsumosAgua : url2 + 'editarconsumosagua',
    consultaConsumoAgua : url2 + 'consumoaguadetalle',
    consultaConsumoDerivaciones : url2 + 'consumoderivaciones',
    actualizaconsumoderivaciones : url2 + "actualizaconsumoderivaciones",
    agregaconstruccion : url2 + 'agregaconstruccion',
    borraconstruccion : url2 + 'borraconstruccion',
    editaconstruccion : url2 + 'editaconstruccion',
    altamanifestacion : url2 + 'altamanifestacion',
    cambiatipovaluacion : url2 + 'cambiatipovaluacion',
    altaconsumoagua : url2 + 'altaconsumoagua',
    generadoccontrib : url2 + 'generadoccontrib',
    buscarContribuyente: url2 + 'buscarcontribuyente',
    buscarContribuyentes: url2 + 'buscarcontribuyentes',
    consultaadeudo: url2 + 'consultaadeudo',
    facturarRecibo: url2 + "facturarrecibo",
    datosFacturacion: url2 + "datosfacturacion",
    generarLineaCaptura: url2 + "generarlineacaptura",
    generarLineaCapturaMeta: url2 + "generarlineacapturameta",
    pagosContribuyente: url2 + "pagoscontribuyente",
    movsContribuyente: url2 + "movscontribuyente",
    movsMedidores: url2 + "historicomedidor",
    movsConsumos : url2 + "historicoconsumos",
    expedientesContribuyente: url2 + "expedientescontribuyente",
    ubicacionContribuyente: url2 + "ubicacioncontribuyente",
    cobro: url2 + "cobroliq",    
    gent3pinpad : url2 +"generar3dpinpad", 
    genct3pinpad : url2 +"generarcan3dpinpad", 
    updct3pinpad : url2 + "senres3dpinpad",
    transacciones3D : url2 + "transacciones3dusuario",
    agregarContribuyente: url2 + "agregarcontribuyente",
    obtenerSiguienteCuenta: url2 + "siguientecontrato",
    obtenerSiguientePredio: url2 + "siguientepredio",
    vinculaAutogestionIusa: url2 + "conectaservicioiusa",
    consultaPredio: url2 + "consultarpredio",
    cancelarCfdi: url2 + "cancelacionfactura",
    actualizarCfdi: url2 + "estadofactura",
    consultarRecibo: url2 + "consultarrecibo",
    consultaDoc: url2+"consultadoc",
    facturasrecibo: url2 + "facturasrecibo",
    cancelarRecibo: url2 + "cancelarrecibo",
    recibo: url2 + "recibo",
    ultrecibo : url2 + "ultreccontribuyente",
    enviarrecibo : url2 + "enviarrecibo",
    registrarCorreoPago: url2 + "registrarcorreopago",
    verificarCorreoPago: url2 + "verificarcorreopago",
    servicios : url2 + "servicios",
    generaPagoEnLinea: url2+"generacionpagoenlinea",
    agregacalle: url2+"agregacalle",
    editanombrecalle : url2 + "editanombrecalle",
    agregacolonia: url2+"agregacolonia",
    agregalocalidad: url2+"agregalocalidad",
    validarclavecat : url2 + "validarclavecat",
    fusionpredios : url2 + "fusionpredios",
    subdivisionpredio : url2 + "subdivisionpredio",
    gruposubsidios: url2 + "gruposubsidios",
    quitasubsidio : url2 + "quitasubsidio",
    agregasubsidio : url2 + "agregasubsidio",
    cambiarpass : url2 + "cambiarpass",
    cambiaroficina : url2 + "cambiaroficina",
    rootsa: url2 + "genkaviraservices",
    contratosiusa : url2 + 'contratosiusaautogestion',
    recorridoactualagua : url2 + 'recorridoactualagua',
    registrarecorridoagua : url2 + 'registrarecorridoagua',

    gendbfs : url2 + 'gendbfs',

    cobroPinpad: urlPinpad,
    pagotarjetaiusa : urlIUSAHost + 'api/values'
    
};

function getPostConfig(ruta, data, token, params){
    return {
        method:"post",
        url: ruta,
        headers: {
            Authorization: token
        },
        params:params,
        data: data
    }
}

function getPostConfigTimeOut(ruta, data, token, params, timeout){
    return {
        timeout : timeout,
        method:"post",
        url: ruta,
        headers: {
            Authorization: token
        },
        params:params,
        data: data
    }
}

function getGetConfig(ruta, data, token, params){
    return {
        method:"get",
        url: ruta,
        headers: {
            Authorization: token
        },
        params:params,
        data: data//en Get axios no soporta el envio de data boby --> https://stackoverflow.com/questions/70445278/axios-get-request-with-body-and-header
    }
}

function handledError(err, ajaxurl, router, store){
    
    var status = err.response ? err.response.status : 0;
    var responseData = err.response ? err.response.data : "";

    var msgError;
    if(status == 0){
        if (err.request && ajaxurl==server.reportes) {
            msgError="El reporte se esta generando. Consulte nuevamente en unos minutos.";
        }else{
            msgError="La petición no pudo ser enviada, revise su conexión a internet o contacte al provedor del sistema para recibir más información de como puede resolver el incidente";
        }
    }else if(status == 400){
        msgError = responseData;
    }else if(status == 401){
        msgError = "Usuario o contraseña incorrectos";
    }else if(status < 500 ){
        //msgError = "La operación no se realizó. Intente nuevamente";
        msgError = responseData;
    }else{
        //msgError = "La operación no se realizó. Intente nuevamente";
        msgError = responseData;
    }
    if(status == 401){
        if (ajaxurl == server.authenticate){
            store.commit("updateMsgErrorLogin", msgError);
        }
        router.push("/"+location.pathname.split("/", 2).toString().replace(",", "")+'/login');
    }else{
        if(ajaxurl == server.liquidacion || ajaxurl== server.exentaPeriodo || ajaxurl==server.gruposubsidios || ajaxurl==server.agregasubsidio || ajaxurl==server.quitasubsidio){
            store.commit("updateMsgErrorLiquidacion", msgError);
        }else if (ajaxurl == server.ordenes || ajaxurl == server.tramites || ajaxurl == server.generartramite){
            store.commit("updateMsgErrorFormasSimple", msgError);
        }else if (ajaxurl == server.ordenpago || ajaxurl == server.cobro || ajaxurl== server.cobroPinpad || ajaxurl==server.gent3pinpad){
            store.commit("updateMsgErrorOrdenPago", msgError);
        }else if (ajaxurl == server.reportes){
            store.commit("updateMsgErrorReportes", msgError);
        }else if (ajaxurl == server.authenticate){
            store.commit("updateMsgErrorLogin", msgError);
        }else if (ajaxurl == server.cancelarorden || ajaxurl == server.recibo || ajaxurl==server.cancelarRecibo || ajaxurl==server.editarPago){
            store.commit("updateMsgFormasCancelar", msgError);
        }else if(ajaxurl == server.consultaadeudo || ajaxurl == server.facturarRecibo || ajaxurl == server.registrarCorreoPago || ajaxurl == server.verificarCorreoPago || ajaxurl == server.consultaDoc){
            store.commit("updateMsgErrorContribuyente", msgError);
        }else if(ajaxurl == server.generarLineaCaptura){
            store.commit("updateMsgErrorGenLinea", msgError);
        }else if(ajaxurl == server.buscarContribuyente 
            || ajaxurl == server.eliminaContribuyente
            || ajaxurl == server.editarContribuyente
            || ajaxurl == server.editarBasesContribuyente
            || ajaxurl == server.editarUbicacionContribuyente
            || ajaxurl == server.altamanifestacion
            || ajaxurl == server.cambiatipovaluacion
            || ajaxurl == server.agregaconstruccion
            || ajaxurl == server.editaconstruccion
            || ajaxurl == server.borraconstruccion
            || ajaxurl == server.pagosContribuyente
            || ajaxurl == server.recibo
            || ajaxurl == server.enviarrecibo
            || ajaxurl == server.expedientesContribuyente
            || ajaxurl == server.ubicacionContribuyente
            || ajaxurl == server.agregacalle
            || ajaxurl == server.generadoccontrib
            || ajaxurl == server.editarConsumosAgua
            || ajaxurl == server.consultaConsumoAgua
            || ajaxurl == server.consultaConsumoDerivaciones
            || ajaxurl == server.altaconsumoagua){
            store.commit("updateMsgErrorPadrones", msgError);
            alert(msgError);
        }else if(ajaxurl == server.validarclavecat || ajaxurl == server.fusionpredios){
            store.commit("updateMsgErrorFusion", msgError);
        }else if(ajaxurl == server.generaPagoEnLinea){
            alert(msgError);
        }else{
            alert(msgError);
        }
    }
    
}

//Se solicita la referencia a router y store
function checkAuth(router, store){
    
    var dateToken = store.state.login.dateToken;
    var token = store.state.login.token;

    if(isTokenValid(token, dateToken)){
        return true;
    }else{
        router.push("/"+location.pathname.split("/", 2).toString().replace(",", "")+'/login')
        return false;
    }
}

export { url, server, server2, checkAuth, getPostConfig, getPostConfigTimeOut, handledError, getGetConfig };